<template>
	<div style="padding: 20px 10px 0 0;">
		<el-dialog :title="title" :visible.sync="show" width="30%" :close-on-click-modal="false"
			:close-on-press-escape="false">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="用户名" prop="userName" :rules="[{ required: true, message: '请输入用户名' }]">
					<el-input v-model="form.userName" :maxlength="50"></el-input>
				</el-form-item>
				<el-form-item label="昵称" prop="nickName" :rules="[{ required: true, message: '请输入昵称' }]">
					<el-input v-model="form.nickName" :maxlength="50"></el-input>
				</el-form-item>
				<el-form-item label="性别">
					<el-radio v-model="form.sex" :label="'0'">男</el-radio>
					<el-radio v-model="form.sex" :label="'1'">女</el-radio>
				</el-form-item>
				<el-form-item label="手机号" prop="phonenumber"
					:rules="[{ required: true, pattern: $store.state.phone, message: '请输入正确手机号' }]">
					<el-input v-model="form.phonenumber" :maxlength="11"></el-input>
				</el-form-item>
				<!--el-form-item label="身份证号" prop="cardId"
					:rules="[{required:true,pattern:$store.state.id,message:'请输入正确身份证号'}]">
					<el-input v-model="form.cardId" :maxlength="18"></el-input>
				</el-form-item-->
				<el-form-item label="角色">
					<el-select v-model="form.roleId">
						<el-option v-for="s in roleList2" :label="s.roleName" :value="s.roleId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="岗位">
					<el-select v-model="form.postId">
						<el-option v-for="s in postList" :label="s.postName" :value="s.postId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="归属部门" prop="deptId">
					<treeselect :disabled="true" v-model="form.deptId" :options="deptOptions" :show-count="true"
						placeholder="请选择归属部门" />
				</el-form-item>
				<!-- <el-form-item label="工号" prop="number">
					<el-input v-model="form.number" :maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="当前住址" prop="address">
					<el-input v-model="form.address"></el-input>
				</el-form-item> -->

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<div class="bottom10 flex sb">
			<div class="flex y">
				<!-- 	<span>管理员姓名</span> -->
				<el-form :inline="true">
					<el-form-item label="用户名">
						<el-input class="left10 right10" v-model="userName" placeholder="请输入用户名" style="width: 150px;"
							clearable></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input class="left10 right10" v-model="phonenumber" placeholder="请输入手机号"
							style="width: 150px;" clearable></el-input>
					</el-form-item>
					<!-- <el-form-item label="身份证">
						<el-input class="left10 right10" v-model="cardId" placeholder="请输入身份证" style="width: 150px;"
							clearable></el-input>
					</el-form-item> -->
					<el-form-item label="角色">
						<el-select v-model="roleId">
							<el-option v-for="s in roleList2" :label="s.roleName" :value="s.roleId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll">搜索</el-button>
						<el-button v-hasPermi="['system:user:add']" type="primary" @click="addRow">新增</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="userName" label="用户名">
				<template slot-scope="{row}">
					{{ row.userName ? row.userName : '未完善' }}
				</template>
			</el-table-column>
			<el-table-column prop="nickName" label="昵称">
				<template slot-scope="{row}">
					{{ row.nickName ? row.nickName : '未完善' }}
				</template>
			</el-table-column>
			<el-table-column prop="sex" label="性别">
				<template slot-scope="{row}">
					{{ row.sex == '0' ? '男' : '女' }}
				</template>
			</el-table-column>
			<el-table-column prop="phonenumber" label="手机号">
				<template slot-scope="{row}">
					{{ row.phonenumber ? row.phonenumber : '未完善' }}
				</template>
			</el-table-column>
			<!--el-table-column prop="cardId" label="身份证">
				<template slot-scope="{row}">
					{{row.cardId?row.cardId:'未完善'}}
				</template>
			</el-table-column-->
			<el-table-column prop="roleName" label="角色">
				<template slot-scope="{row}">
					{{ row.roleName ? row.roleName : '未完善' }}
				</template>
			</el-table-column>
			<el-table-column prop="postName" label="岗位">
				<template slot-scope="{row}">
					{{ row.postName ? row.postName : '未完善' }}
				</template>
			</el-table-column>
			<el-table-column prop="deptName" label="部门">
				<template slot-scope="{row}">
					{{ row.deptName ? row.deptName : '未完善' }}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间">
				<template slot-scope="{row}">
					{{ setTime(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="操作">
				<template slot-scope="{row}">
					<el-button v-hasPermi="['system:user:remove']" type="text" @click="delRow(row)">删除</el-button>
					<el-button v-hasPermi="['system:user:edit']" type="text" @click="setRow(row)">编辑</el-button>
					<!-- <el-button v-hasPermi="['system:user:edit']" type="text" @click="imageUp(row)">上传照片</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background :page-size="pageSize" layout="total, prev, pager, next,sizes"
			@current-change="handleCurrentChange" :total="totalNum" @size-change="handleSizeChange" />


		<el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
			<el-image v-if="userImage" style="width:100%;" :src="userImage"> </el-image>
			<el-upload ref="upload" :limit="1" accept=".jpg, .png" :headers="upload.headers" :action="upload.url"
				:disabled="upload.isUploading" :on-progress="handleFileUploadProgress" :on-success="handleFileSuccess"
				drag :before-upload="beforeAvatarUpload">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				<span>仅允许jpg、png格式文件。</span>

				<!--  <div class="el-upload__tip text-center" slot="tip">
                    <div class="el-upload__tip" slot="tip">

                    </div>
                   <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
                        @click="importTemplate">下载模板</el-link> 
                </div>-->
			</el-upload>

			<div slot="footer" class="dialog-footer">
				<el-button v-if="!upload.isUploading" size="small" type="primary" @click="submitFileForm">确
					定</el-button>
				<el-button v-else type="primary" size="small" :loading="true">导入中</el-button>
				<el-button size="small" @click="upload.open = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
	components: { Treeselect },
	watch: {
		"$route"() {
			// this.oldForm.roleId = this.getRoleId()
			// this.form.roleId = this.getRoleId()
			// this.form.deptId = this.oldForm.deptId = this.$route.params.id
			this.getAll()
			this.getRoleList()
			this.getPostId()
		}
	},
	data() {
		return {
			userImage: "",
			paramsData: { userId: "" },
			// 用户导入参数
			upload: {
				// 是否显示弹出层（用户导入）
				open: false,
				// 弹出层标题（用户导入）
				title: "照片上传",
				// 是否禁用上传
				isUploading: false,

				// 设置上传的请求头部
				headers: {
					Authorization: localStorage.access_token
				},
				// 上传的地址
				url: "/api/safeSign/userFace/upload"
			},
			oldForm: "",
			roleList: [],
			roleList2: [
				{
					roleId: 4,
					roleName: "物业管理员"
				},
				{
					roleId: 11,
					roleName: "安保负责人"
				},
				{
					roleId: 12,
					roleName: "客服"
				},
				{
					roleId: 13,
					roleName: "工程"
				},
				{
					roleId: 14,
					roleName: "保洁"
				},
				{
					roleId: 15,
					roleName: "安保员工"
				},
				// {
				// 	roleId: 17,
				// 	roleName: "值班经理"
				// },
			],
			postId: "",
			roleId: "",
			totalNum: 0,
			form: {
				address: "",
				number: "",
				userName: "",
				nickName: '',
				sex: "男",
				phonenumber: "",
				cardId: "",
				postId: '',
				roleId: "",
				// roleId: this.$route.params.name == "学校管理员" ? 3 : this.$route.params.name == "公寓管理员" ? 2 : this.$route
				// 	.params.name == "保洁部" ? 9 : 5,
				//deptId: this.$route.params.id
				deptId: 184
			},
			title: "新增",
			show: false,
			pageNum: 1, //当前页
			pageSize: 10, //页大小
			name: "", //模糊查询
			phone: "",
			cardId: "",
			userName: '',
			phonenumber: '',
			data: [], //表格数据
			postList: [],
			deptOptions: []
		}
	},
	methods: {
		getImage() {
			this.userImage = "";
			this.$http.get(`/api/safeSign/userFace/getPhotoDetail?userId=${this.paramsData.userId}`).then(res => {
				if (res.data.code == 200) {
					this.userImage = res.data.data.photoPath
				} else {
					this.$message.error(`${res.data.msg}`);
				}
				// this.deptOptions = res.data.data
			})
		},
		// 文件上传中处理
		handleFileUploadProgress(event, file, fileList) {
			this.upload.isUploading = true;
		},
		// 文件上传成功处理
		handleFileSuccess(response, file, fileList) {
			this.upload.isUploading = false;
			this.$refs.upload.clearFiles();
			console.log(response)
			if (response.code == 200) {
				this.upload.open = false;
				this.$message.success(`上传成功!`);
			} else {
				this.$message.error(`${response.msg}`);
			}
		},
		// 提交上传文件
		submitFileForm() {
			this.$refs.upload.submit();
		},
		// 上传之前
		beforeAvatarUpload(file) {
			if (this.paramsData.userId == "") {
				return false;
			}
			return true;
		},
		imageUp(row) {
			this.paramsData.userId = row.userId;
			this.upload.url = "/api/safeSign/userFace/upload?userId=" + row.userId;
			this.getImage();
			this.upload.open = true;
		},
		// 分页
		// 当前页
		handleCurrentChange(val) {
			this.pageNum = val;
			this.getAll();
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getAll();
		},
		getDeptId() {
			this.$http.get(`/api/system/dept/treeselect2`).then(res => {
				console.log(res.data.data)
				this.deptOptions = res.data.data
			})
		},
		getPostId() {
			this.$http.get("/api/system/post/list2/list2").then(res => {
				console.log(res)
				this.postList = res.data.rows
			})
		},
		getRoleList() {
			this.$http.get("/api/system/role/list2/list2").then(res => {
				console.log(res)
				this.roleList = res.data.rows
			})
		},
		getRoleId() {
			if (this.$route.params.name == "公寓管理员") {
				return 2
			}
			if (this.$route.params.name == "管理员") {
				return 3
			}
			if (this.$route.params.name == "客服部") {
				return 5
			}
			if (this.$route.params.name == "工程部") {
				return 6
			}
			if (this.$route.params.name == "安保部") {
				return 7
			}
			if (this.$route.params.name == "保洁部") {
				return 9
			}
		},
		ok() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					let url = "/api/system/user/edit"
					if (this.title[0] == "新") {
						url = "/api/system/user/add"
					}
					// this.form.roleId=this.getRoleId();
					this.$http.post(url, this.form).then(res => {
						if (res.data.code == 200) {
							this.$message.success(res.data.msg);
							this.show = false
							this.getAll()
						}
						if (res.data.code == -1) {
							this.$message.error(res.data.msg)
						}
						if (res.data.code == 500) {
							console.log('error:', JSON.stringify(res.data))
							this.$message.error(res.data.msg)
						}
					})
				} else {
					return false;
				}
			});
		},
		getAll() { //获取表格分页数据
			this.$http.get(`/api/system/user/list2`, {
				params: {
					deptId: 184,
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					userName: this.userName,
					phonenumber: this.phonenumber,
					roleId: this.roleId,
					// cardId: this.cardId
				}
			}).then(res => {
				this.data = res.data.rows
				this.totalNum = res.data.total
			})
		},
		setRow(obj) {
			this.title = "修改"
			console.log(obj)
			this.form = JSON.parse(JSON.stringify(obj))
			//console.log('form:',JSON.stringify(this.form))
			this.show = true
		},
		addRow() {
			this.title = "新增"
			this.form = JSON.parse(JSON.stringify(this.oldForm))
			this.show = true
		},
		delRow(obj) { //删除被点击
			console.log(obj)
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.get(`/api/system/user/delete`, {
					params: {
						userId: obj.userId
					}
				}).then(res => {
					this.$message.success(res.data.msg)
					this.getAll()
				})
			}).catch(() => { });
		}
	},
	mounted() {
		this.oldForm = JSON.parse(JSON.stringify(this.form))
		this.getAll()
		this.getRoleList()
		this.getPostId()
		this.getDeptId()
	}
}
</script>

<style>

</style>
